import { jsx as _jsx } from "react/jsx-runtime";
import { sizes } from '../../../../const/sizes';
import { Text } from '../../../Text/Text';
import { FlexContainer } from '../../../layout/FlexContainer';
export const CalendarShortWeekDays = ({ shortWeekDays, }) => {
    return (_jsx(FlexContainer, { spacingVertical: '1', gap: '1/2', center: true, children: shortWeekDays.map((day) => (_jsx(FlexContainer, { minHeight: sizes.calendar.shortWeekDays.textHeight, minWidth: sizes.calendar.shortWeekDays.textWidth, center: true, children: _jsx(Text, { variant: 'b2', color: 'grey', minWidth: sizes.calendar.shortWeekDays.textWidth, align: 'center', children: day }) }, day))) }));
};
